/**
 * Chuyển các giá trị string có dạng biến (vd: "{totalNoti?.length}") thành giá trị thực từ context
 * @param item 1 object config từ JSON
 * @param keysToResolve các key muốn convert từ string thành giá trị thực
 * @param context object chứa các biến hiện có define sẵn lấy từ redux ra
 * @returns object mới với các key đã được giải giá trị
 */
export const resolveDynamicProps = (
      item: Record<string, any>,
      keysToResolve: string[],
      context: Record<string, any>
) =>
{
      const resolvedItem = { ...item };

      keysToResolve.forEach((key) =>
      {
            const rawValue = item[key];
            if (typeof rawValue === "string" && rawValue.includes("?."))
            {
                  const cleaned = rawValue.replace(/[{}]/g, "").trim(); // "{a?.b?.c}" => "a?.b?.c"
                  const segments = cleaned.split("?.");

                  let result = context[segments[0]];
                  for (let i = 1; i < segments.length; i++)
                  {
                        result = result?.[segments[i]];
                  }

                  resolvedItem[key] = result;
            }
      });

      return resolvedItem;
};
